"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var Company_1;
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("@powerednow/shared/constants");
const subscription_1 = require("@powerednow/shared/constants/subscription");
const userProfileRoleCustom_1 = __importDefault(require("@powerednow/shared/constants/userProfileRoleCustom"));
const array_1 = __importDefault(require("@powerednow/shared/modules/utilities/array"));
const converter_1 = __importDefault(require("@powerednow/shared/modules/utilities/converter"));
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const syncable_1 = __importDefault(require("@powerednow/complexData/mixin/syncable"));
const decorator_1 = require("@powerednow/complexData/decorator");
const date_1 = require("@powerednow/shared/modules/utilities/date");
const textUtils_1 = __importDefault(require("@powerednow/shared/modules/utilities/textUtils"));
const themeConfig_1 = __importDefault(require("@powerednow/documentLayouts/themeConfig"));
const modelLookup_1 = require("../modelLookup");
const entity_1 = __importStar(require("./entity"));
const modelProperties_1 = __importDefault(require("./modelProperties"));
const bookingSlotManager_1 = __importDefault(require("../../utilities/bookingSlotManager"));
const subscriptionInfo_1 = __importDefault(require("./subscriptionInfo"));
const renderData_1 = __importDefault(require("./renderData"));
let Company = Company_1 = 
// eslint-disable-next-line no-redeclare
class Company extends complexData_1.default {
    constructor() {
        super(...arguments);
        this.subscriptionInfo = null;
    }
    static get allowedAssociations() {
        return {
            companyWorkflow: {
                key: 'companyWorkflow',
                instance: (0, modelLookup_1.complexFindModel)('CompanyWorkflow'),
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                },
            },
            productCategory: {
                key: 'productCategory',
                instance: (0, modelLookup_1.complexFindModel)('ProductCategory'),
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                },
            },
            xeroIntegration: {
                key: 'companyIntegration',
                single: true,
                cascadeDelete: false,
                instance: (0, modelLookup_1.complexFindModel)('CompanyIntegration'),
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                    integration_type_id: constants_1.INTEGRATION.INTEGRATION_TYPE.XERO,
                },
            },
            appointmentType: {
                key: 'appointmentType',
                instance: (0, modelLookup_1.complexFindModel)('AppointmentType'),
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                },
            },
            editableAppointmentType: {
                key: 'appointmentType',
                instance: (0, modelLookup_1.complexFindModel)('AppointmentType'),
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                    editable: true,
                },
            },
            externalEditableAppointmentType: {
                key: 'appointmentType',
                instance: (0, modelLookup_1.complexFindModel)('AppointmentType'),
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                    editable: true,
                    isExternal: true,
                },
            },
            internalEditableAppointmentType: {
                key: 'appointmentType',
                instance: (0, modelLookup_1.complexFindModel)('AppointmentType'),
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                    editable: true,
                    isInternal: true,
                },
            },
            bookingDateException: {
                key: 'bookingDateException',
                instance: (0, modelLookup_1.complexFindModel)('BookingDateException'),
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                },
            },
            appointment: {
                key: 'action',
                instance: (0, modelLookup_1.complexFindModel)('Action'),
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                    type: constants_1.ACTION.ACTION_TYPES.ACTION_TYPE_APPOINTMENT,
                },
            },
            holiday: {
                key: 'action',
                instance: (0, modelLookup_1.complexFindModel)('Action'),
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                    type: constants_1.ACTION.ACTION_TYPES.ACTION_TYPE_HOLIDAY_SICKNESS_OR_OTHER,
                },
            },
            purchases: {
                key: 'purchases',
                instance: (0, modelLookup_1.complexFindModel)('Purchases'),
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                },
            },
            companyAddress: {
                key: 'companyAddress',
                instance: (0, modelLookup_1.complexFindModel)('CompanyAddress'),
                single: true,
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                    is_registered: true,
                },
            },
            invoiceAddress: {
                key: 'companyAddress',
                instance: (0, modelLookup_1.complexFindModel)('CompanyAddress'),
                single: true,
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                    is_invoice: true,
                    is_registered: false,
                },
            },
            userProfileRoleCustom: {
                key: 'userProfileRoleCustom',
                instance: (0, modelLookup_1.complexFindModel)('UserProfileRoleCustom'),
                cascadeDelete: false,
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                },
            },
            currency: {
                key: 'currency',
                instance: (0, modelLookup_1.complexFindModel)('Currency'),
                single: true,
                condition: {
                    id: Company_1.Entity.getForeignFieldSymbols().currency_id,
                },
            },
            documentLogo: {
                key: 'documentLogo',
                instance: (0, modelLookup_1.complexFindModel)('DocumentLogo'),
                cascadeDelete: false,
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                    document_type: constants_1.LOGO.DOCUMENT_TYPE.DOCUMENT,
                },
            },
            uploadedDocumentLogo: {
                key: 'documentLogo',
                instance: (0, modelLookup_1.complexFindModel)('DocumentLogo'),
                cascadeDelete: false,
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                    document_type: constants_1.LOGO.DOCUMENT_TYPE.DOCUMENT,
                    $or: [
                        { status: 'uploaded' }, // legacy
                        { status: 'uploading' }, // legacy
                        { status: constants_1.FILE_UPLOAD.STATUS.UPLOADED },
                        { status: constants_1.FILE_UPLOAD.STATUS.UPLOADING },
                    ],
                },
            },
            companyLogo: {
                key: 'documentLogo',
                instance: (0, modelLookup_1.complexFindModel)('DocumentLogo'),
                single: true,
                cascadeDelete: false,
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                    document_type: constants_1.LOGO.DOCUMENT_TYPE.CUSTOMER_PORTAL_LOGO,
                    isCompanyLogo: true,
                },
            },
            formLogo: {
                key: 'documentLogo',
                instance: (0, modelLookup_1.complexFindModel)('DocumentLogo'),
                single: true,
                cascadeDelete: false,
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                    document_type: constants_1.LOGO.DOCUMENT_TYPE.FORM_DOCUMENT,
                },
            },
            companySettings: {
                key: 'companySettings',
                instance: (0, modelLookup_1.complexFindModel)('CompanySettings'),
                cascadeDelete: false,
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                },
            },
            paymentSetting: {
                key: 'paymentSetting',
                instance: (0, modelLookup_1.complexFindModel)('PaymentSetting'),
                cascadeDelete: false,
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                },
            },
            mainUser: {
                key: 'user',
                instance: (0, modelLookup_1.complexFindModel)('User'),
                single: true,
                cascadeDelete: false,
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                    is_main: true,
                },
            },
            users: {
                key: 'user',
                instance: (0, modelLookup_1.complexFindModel)('User'),
                cascadeDelete: false,
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                },
            },
            customer: {
                key: 'customer',
                instance: (0, modelLookup_1.complexFindModel)('Customer'),
                cascadeDelete: false,
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                },
            },
            supplier: {
                key: 'customer',
                instance: (0, modelLookup_1.complexFindModel)('Customer'),
                cascadeDelete: false,
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                    is_supplier: true,
                },
            },
            job: {
                key: 'job',
                instance: (0, modelLookup_1.complexFindModel)('Job'),
                cascadeDelete: false,
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                },
            },
            document: {
                key: 'document',
                instance: (0, modelLookup_1.complexFindModel)('Document'),
                cascadeDelete: false,
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                },
            },
            formDocument: {
                key: 'formDocument',
                instance: (0, modelLookup_1.complexFindModel)('FormDocument'),
                cascadeDelete: false,
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                },
            },
            feature: {
                key: 'feature',
                instance: (0, modelLookup_1.complexFindModel)('Feature'),
                single: true,
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                },
            },
            consumptionExtra: {
                key: 'consumptionExtra',
                instance: (0, modelLookup_1.complexFindModel)('ConsumptionExtra'),
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                },
            },
            consumptionStats: {
                key: 'consumptionStats',
                instance: (0, modelLookup_1.complexFindModel)('ConsumptionStats'),
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                },
            },
            extraUser: {
                key: 'consumptionExtra',
                instance: (0, modelLookup_1.complexFindModel)('ConsumptionExtra'),
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                    type: constants_1.CONSUMPTION_EXTRA.TYPES.user,
                },
            },
            extraDocument: {
                key: 'consumptionExtra',
                instance: (0, modelLookup_1.complexFindModel)('ConsumptionExtra'),
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                    type: constants_1.CONSUMPTION_EXTRA.TYPES.document,
                },
            },
            whiteLabel: {
                single: true,
                key: 'whiteLabel',
                instance: (0, modelLookup_1.complexFindModel)('WhiteLabel'),
                condition: {
                    id: Company_1.Entity.getFieldSymbols().whitelabel_id,
                },
            },
            lockDate: {
                key: 'lockDate',
                instance: (0, modelLookup_1.complexFindModel)('LockDate'),
                condition: {
                    company_id: Company_1.Entity.getFieldSymbols().id,
                },
            },
            documentLayout: {
                key: 'documentLayout',
                instance: (0, modelLookup_1.complexFindModel)('DocumentLayout'),
                single: true,
                condition: {
                    id: Company_1.Entity.getFieldSymbols().default_document_template,
                },
            },
        };
    }
    async getDateFormat() {
        const address = await this.getCompanyAddress();
        const country = await address?.getCountry();
        return country?.data.date_format;
    }
    async hasEverSubscribed() {
        return (await this.getAllPurchases()).length > 0;
    }
    async hasBookableAppointmentSlots() {
        const appointmentScheduleSettings = await this.getJSONCompanySetting(constants_1.SETTINGS_KEYS.APPOINTMENTS_DAILY_SCHEDULE);
        return appointmentScheduleSettings?.allowOnlineBooking;
    }
    async getBookableAppointmentSlotsByAppointment(appointmentTypeId, timeZoneShift = 0) {
        const appointmentScheduleSettings = await this.getJSONCompanySetting(constants_1.SETTINGS_KEYS.APPOINTMENTS_DAILY_SCHEDULE);
        const { firstBookableDay, lastBookableDay, } = bookingSlotManager_1.default.initBookableInterval(appointmentScheduleSettings);
        firstBookableDay.setHours(-timeZoneShift);
        lastBookableDay.setHours(-timeZoneShift);
        const allBookingExceptions = await this.getAllBookingDateException();
        const allAppointments = await this.getAllAppointment({
            filters: [{
                    property: 'dt_start',
                    operator: '<',
                    value: lastBookableDay,
                }, {
                    property: 'dt_end',
                    operator: '>',
                    value: firstBookableDay,
                }],
        });
        const allHolidays = await this.getAllHoliday();
        const slotManager = new bookingSlotManager_1.default({
            scheduleSettings: appointmentScheduleSettings,
            bookingExceptions: allBookingExceptions,
            appointments: allAppointments,
            holidays: allHolidays,
            timeZoneShift,
        });
        const appointmentType = await this.getAppointmentTypeById(appointmentTypeId);
        const availableSlots = slotManager.getBookableDays(appointmentType);
        return {
            availableSlots,
            firstBookableDay: slotManager.getFirstBookableDay(availableSlots),
            lastBookableDay: slotManager.getLastBookableDay(availableSlots),
        };
    }
    async isLookupCountryFeatureAvailable(lookupTypeCode) {
        const allowedLookupTypes = (await this.getAllowedLookupCountryFeaturesByCode([
            lookupTypeCode,
        ]));
        return Object.keys(allowedLookupTypes).length === 1;
    }
    async isCountryFeatureAvailable(type) {
        const allowedCountryFeatures = await this.getCountryFeaturesForType(type);
        return (allowedCountryFeatures || []).length > 0;
    }
    async getCountryFeaturesForType(type) {
        const country = await this.findCountry();
        return country.getFeaturesForType(type);
    }
    async getAllowedLookupCountryFeaturesByCode(lookupTypeCodes) {
        return (await this.getCountryFeaturesForType(constants_1.COUNTRY_FEATURE.TYPE.COMPANY_LOOKUP))
            .reduce((allowedFeatures, countryFeature) => {
            const typeDefinition = constants_1.PARTNER_LOOKUP.TYPES[countryFeature.data.params];
            if (typeDefinition && lookupTypeCodes.includes(typeDefinition.CODE)) {
                return {
                    ...allowedFeatures,
                    [typeDefinition.CODE]: countryFeature,
                };
            }
            return allowedFeatures;
        }, {});
    }
    async getWhiteLabelId() {
        const whiteLabel = await this.getWhiteLabel();
        return Number(whiteLabel?.data?.fallback_whitelabel_id || whiteLabel?.data?.id) || null;
    }
    async getSubscriptionInfo(trialId, expiredId, whitelabelId) {
        const finalWhitelabelId = whitelabelId || await this.getWhiteLabelId();
        const finalTrialId = trialId || subscription_1.WHITE_LABEL_TRIAL_MAP[finalWhitelabelId];
        const finalExpiredId = expiredId || subscription_1.WHITE_LABEL_EXPIRED_MAP[finalWhitelabelId];
        if (!this.subscriptionInfo) {
            this.subscriptionInfo = new subscriptionInfo_1.default(this);
            if (finalTrialId) {
                this.subscriptionInfo.setTrialId(finalTrialId);
            }
            if (finalExpiredId) {
                this.subscriptionInfo.setExpiredId(finalExpiredId);
            }
            if (finalWhitelabelId) {
                this.subscriptionInfo.setWhiteLabelId(finalWhitelabelId);
            }
            await this.subscriptionInfo.init();
        }
        return this.subscriptionInfo;
    }
    invalidateSubscriptionInfo() {
        this.subscriptionInfo = null;
    }
    async getSerializableSubscriptionInfo() {
        const original = await this.getSubscriptionInfo();
        const { company, ...serializable } = original;
        return serializable;
    }
    async isCISAvailable() {
        const country = await this.findCountry();
        return country.data.is_cis;
    }
    getPhone() {
        return this.dataValues?.phone || null;
    }
    async canUseCIS() {
        return this.data.cis_enabled && this.isCISAvailable();
    }
    async getLastPurchased() {
        return (await this.getAllPurchases())
            .sort((a, b) => (a.data.purchase_date <= b.data.purchase_date ? 1 : -1));
    }
    static async getCompanyCountryId(complexObject) {
        const response = await complexObject.loadGenericData((0, modelLookup_1.complexFindModel)('CompanyAddress'), { is_registered: true });
        const registeredCompanyAddress = response && response.responseData[0];
        return registeredCompanyAddress ? registeredCompanyAddress.country_id : constants_1.COUNTRY.IDS.UNITED_KINGDOM;
    }
    static async getCompanyCountry(complexObject) {
        const companyCountryId = await Company_1.getCompanyCountryId(complexObject);
        const response = await complexObject.loadGenericData((0, modelLookup_1.complexFindModel)('Country'), { id: companyCountryId });
        const companyCountry = response && response.responseData[0];
        return companyCountry;
    }
    async requiresCheckForMandatoryProductCategory() {
        const companyCountry = await this.findCountry();
        return companyCountry.isUkOrIOM();
    }
    async findRoles() {
        const roles = await this.findDefaultRoles();
        return this.mergeCustomRoles(roles);
    }
    async findDefaultRoles() {
        const roles = [];
        const userProfileRoles = await this.findUserProfileRoles(this);
        userProfileRoles.forEach(userProfileRole => {
            roles.push(this.generateUserRole(userProfileRole.data.role_id, userProfileRole.data.userprofile_id));
        });
        return roles;
    }
    async findUserProfileRoles(complexObject) {
        const response = await complexObject.loadGenericData((0, modelLookup_1.complexFindModel)('UserProfileRole'));
        const userProfileRoleData = response && response.responseData;
        return userProfileRoleData.map(data => new ((0, modelLookup_1.complexFindModel)('UserProfileRole'))(data));
    }
    generateUserRole(roleId, userProfileId) {
        return new ((0, modelLookup_1.complexFindModel)('UserProfileRole'))({
            role_id: roleId,
            userprofile_id: userProfileId,
        });
    }
    async mergeCustomRoles(roles) {
        let newRoles = roles;
        const userProfileRoleCustoms = await this.getAllUserProfileRoleCustom();
        userProfileRoleCustoms.forEach(userProfileRoleCustom => {
            const role = this.generateUserRole(userProfileRoleCustom.data.role_id, userProfileRoleCustom.data.userprofile_id);
            if (userProfileRoleCustom.data.mode === userProfileRoleCustom_1.default.MODE.ADD) {
                newRoles = array_1.default.deepUniquePush(newRoles, role);
            }
            else if (userProfileRoleCustom.data.mode === userProfileRoleCustom_1.default.MODE.REMOVE) {
                newRoles = array_1.default.deepRemove(newRoles, role);
            }
        });
        return newRoles;
    }
    async findCountryId() {
        const country = await this.findCountry();
        return country.data.id;
    }
    async findCountry() {
        const companyAddress = await this.getCompanyAddress();
        return companyAddress.getCountry();
    }
    async getPaymentTypes() {
        const country = await this.findCountry();
        return country.getAvailablePayments();
    }
    async getCompanySettingOrNull(settingId) {
        const settingValue = await this.findCompanySetting(settingId);
        return settingValue?.data?.setting_value || null;
    }
    async findCompanySetting(settingId) {
        const allSettings = await this.getAllCompanySettings();
        return allSettings.find((settings) => settings.data.setting_key_id === settingId);
    }
    async getEveningHoursSettings() {
        return this.getJSONCompanySetting(constants_1.SETTINGS_KEYS.EVENING_HOURS);
    }
    async getLunchTimeSettings() {
        return this.getJSONCompanySetting(constants_1.SETTINGS_KEYS.LUNCH_TIME);
    }
    async getDefaultDurationLengthSettings() {
        const defaultAppointmentDuration = Number(await this.getSettingValue(constants_1.SETTINGS_KEYS.DEFAULT_APPOINTMENT_LENGTH));
        const defaultAppointmentDurationId = Number(await this.getSettingValue(constants_1.SETTINGS_KEYS.DEFAULT_APPOINTMENT_DURATION_ID));
        const defaultDurations = constants_1.ACTION.CUSTOM_APPOINTMENT_TYPE.DEFAULT_DURATION;
        // We must find the option based on id and value
        let selectedDefaultDuration = defaultDurations.find(defaultDuration => defaultDuration.duration_id === defaultAppointmentDurationId
            && defaultDuration.value === defaultAppointmentDuration);
        if (!selectedDefaultDuration) {
            selectedDefaultDuration = defaultDurations.find(defaultDuration => defaultDuration.value === defaultAppointmentDuration) || defaultDurations[0];
        }
        return selectedDefaultDuration.id;
    }
    async setDefaultDurationLengthSettings(durationLengthId) {
        const defaultDurations = constants_1.ACTION.CUSTOM_APPOINTMENT_TYPE.DEFAULT_DURATION;
        let selectedDefaultDuration = defaultDurations.find(defaultDuration => defaultDuration.id === durationLengthId);
        if (!selectedDefaultDuration) {
            [selectedDefaultDuration] = defaultDurations;
        }
        return {
            defaultAppointmentDuration: await this.setSettingValue(constants_1.SETTINGS_KEYS.DEFAULT_APPOINTMENT_LENGTH, selectedDefaultDuration.value),
            defaultAppointmentDurationId: await this.setSettingValue(constants_1.SETTINGS_KEYS.DEFAULT_APPOINTMENT_DURATION_ID, selectedDefaultDuration.duration_id),
        };
    }
    async getJSONCompanySetting(settingId) {
        return this.getParsedSettingValue(settingId);
    }
    async getBooleanCompanySetting(settingId) {
        const setting = await this.getParsedSettingValue(settingId);
        return Boolean(setting);
    }
    async getSettingValue(settingId) {
        const setting = await this.findCompanySetting(settingId);
        if (!setting) {
            return (0, modelLookup_1.complexFindModel)('SettingsKeys').getDefaultSettingValue(settingId, this);
        }
        return setting.data.setting_value;
    }
    async getParsedSettingValue(settingId) {
        const settingValue = await this.getSettingValue(settingId);
        if (typeof settingValue === 'string') {
            try {
                return JSON.parse(settingValue);
            }
            catch (e) {
                return settingValue;
            }
        }
        return settingValue;
    }
    async setSettingValue(settingId, value) {
        let setting = await this.findCompanySetting(settingId);
        if (!setting) {
            setting = await this.addCompanySettings({
                setting_key_id: settingId,
                setting_value: value,
            });
        }
        else {
            setting.data.setting_value = value;
        }
        return setting;
    }
    showRemindersInDiary() {
        const { show_reminders_in_diary: showRemindersInDiary } = this.data.companySettings;
        const emptyValues = [undefined, null];
        if (emptyValues.includes(showRemindersInDiary)) {
            return true;
        }
        return showRemindersInDiary;
    }
    async getNotificationChannels() {
        const useSms = converter_1.default.stringToBoolean(await this.getSettingValue(constants_1.SETTINGS_KEYS.CUSTOMER_APPOINTMENT_NOTIFICATION_BYTEXT));
        const useEmail = converter_1.default.stringToBoolean(await this.getSettingValue(constants_1.SETTINGS_KEYS.CUSTOMER_APPOINTMENT_NOTIFICATION_BYEMAIL));
        const useWhatsapp = converter_1.default.stringToBoolean(await this.getSettingValue(constants_1.SETTINGS_KEYS.CUSTOMER_APPOINTMENT_NOTIFICATION_BY_WHATSAPP));
        return [
            ...(useSms ? ['SMS'] : []),
            ...(useEmail ? ['EMAIL'] : []),
            ...(useWhatsapp ? ['WHATSAPP'] : []),
        ];
    }
    setNotifyData(data) {
        const fields = [
            entity_1.NOTIFICATION.NOTIFY_ON_QUOTE,
            entity_1.NOTIFICATION.NOTIFY_ON_PAYMENT,
            entity_1.NOTIFICATION.NOTIFY_ON_TASK,
            entity_1.NOTIFICATION.NOTIFY_ON_READS,
            entity_1.NOTIFICATION.NOTIFY_ON_EMAIL,
            entity_1.NOTIFICATION.NOTIFY_ON_CHAT,
            entity_1.NOTIFICATION.NOTIFY_MAIN_EMAILS,
            entity_1.NOTIFICATION.INVITE_CUSTOMER_ON_APPOINTMENT_SYNC,
            entity_1.NOTIFICATION.INVITE_ALLOCATED_USER_ON_APPOINTMENT_SYNC,
            entity_1.NOTIFICATION.NOTIFY_ON_CUSTOMER_APPOINTMENT,
            entity_1.NOTIFICATION.NOTIFY_ON_USER_LOGIN,
        ];
        const newNotificationSettings = fields.reduce((settings, field) => {
            if (typeof (data[field]) !== 'undefined') {
                return {
                    ...settings,
                    [field]: data[field],
                };
            }
            return settings;
        }, {});
        this.data.notify_settings = {
            ...this.data.notify_settings,
            ...newNotificationSettings,
        };
    }
    async getPaymentSettingByPaymentTypeId(paymentTypeId) {
        const paymentSettings = await this.getAllPaymentSetting();
        return paymentSettings.find(paymentSetting => paymentSetting.data.payment_id === paymentTypeId);
    }
    workdayHalfTime() {
        const QUARTER_TIME = 15;
        const start = (0, date_1.getTimeParts)(this.dataValues.workday_start);
        const end = (0, date_1.getTimeParts)(this.dataValues.workday_end);
        const differenceInMinutes = end.fullMinutes - start.fullMinutes;
        const finalDate = new Date();
        finalDate.setHours(start.hour);
        finalDate.setMinutes(start.minutes + Math.round(differenceInMinutes / 2));
        const finalMinutes = finalDate.getMinutes();
        const quarterMinutes = Math.round(finalMinutes / QUARTER_TIME) * QUARTER_TIME;
        finalDate.setMinutes(quarterMinutes);
        return `${finalDate.getHours()}:${finalDate.getMinutes()}`;
    }
    async getAppointmentTypeRelatedSettings() {
        const vatRegistered = this.data?.vat_registered;
        const displayPrice = await this.getParsedSettingValue(constants_1.SETTINGS_KEYS.BOOK_APPOINTMENT_DISPLAY_PRICE);
        const country = await this.findCountry();
        const isUK = country?.data?.id === constants_1.COUNTRY.IDS.UNITED_KINGDOM;
        let promptId = '';
        let promptValue = '';
        if (vatRegistered) {
            const taxInclusive = this.data?.tax_inclusive;
            if (taxInclusive) {
                if (isUK) {
                    promptId = 'Settings.IncludingVatShort';
                    promptValue = 'inc. VAT';
                }
                else {
                    promptId = 'Settings.IncludingTaxShort';
                    promptValue = 'inc. Tax';
                }
            }
            else if (isUK) {
                promptId = 'Settings.ExcludingVatShort';
                promptValue = 'exc. VAT';
            }
            else {
                promptId = 'Settings.ExcludingTaxShort';
                promptValue = 'exc. Tax';
            }
        }
        const promptValues = {
            id: promptId, value: promptValue,
        };
        return {
            vatRegistered, displayPrice, isUK, promptValues,
        };
    }
    async getLocaleInfo() {
        const companyAddress = await this.getCompanyAddress();
        const { city } = companyAddress.data;
        const country = await companyAddress.getCountry();
        return { city, countryCode: country.data.code };
    }
    getFooter(documentType) {
        return this.data[`default${textUtils_1.default.capitalize(constants_1.DOCUMENT.TYPES[constants_1.DOCUMENT.DOCUMENT_HEADER_FOOTER_TYPES[documentType]])}Footer`] || '';
    }
    getHeader(documentType) {
        return this.data[`default${textUtils_1.default.capitalize(constants_1.DOCUMENT.TYPES[constants_1.DOCUMENT.DOCUMENT_HEADER_FOOTER_TYPES[documentType]])}Header`] || '';
    }
    getDueDate(issueDate) {
        return (0, date_1.addDays)(this.data.defaultPaymentTerm, issueDate).format('YYYY-MM-DD HH:mm:ss');
    }
    async getAllEnvelopeType() {
        return (0, modelLookup_1.complexFindModel)('EnvelopeType').getAll(this);
    }
    async getDefaultEnvelopeSettings() {
        const envelopeTypes = await this.getAllEnvelopeType();
        const defaultEnvelopeTypeId = 1;
        const defaultRecord = envelopeTypes.find(item => item.data.id === defaultEnvelopeTypeId);
        if (defaultRecord) {
            return defaultRecord.data.getDataValues();
        }
        return {
            name: constants_1.DOCUMENT.ENVELOPE.name,
            id: constants_1.DOCUMENT.ENVELOPE.id,
            windowLeftOffset: constants_1.DOCUMENT.ENVELOPE.windowLeftOffset,
            windowTopOffset: constants_1.DOCUMENT.ENVELOPE.windowTopOffset,
        };
    }
    async getEnvelopeTypeSettings() {
        const envelopeTypes = await this.getAllEnvelopeType();
        const defaultEnvelope = await this.getDefaultEnvelopeSettings();
        const { envelope_settings } = this.data;
        if (envelope_settings && envelope_settings.typeId) {
            const envelopeType = envelopeTypes.find(item => item.data.id === parseInt(envelope_settings.typeId, 10));
            return { ...envelopeType.data.getDataValues(), ...envelope_settings };
        }
        return defaultEnvelope;
    }
    async getDocumentRenderData(L, args) {
        const renderer = new renderData_1.default(L, this, args);
        return renderer.getDocumentTemplateData();
    }
    async getWorkflowsByWorkflowId(workflowId) {
        const workflows = await this.getAllCompanyWorkflow();
        return workflows.filter(workflow => workflow.data.workflow_id === workflowId);
    }
    async getThemeConfig() {
        const layout = await this.getDocumentLayout();
        return layout.getThemeConfig();
    }
    async getThemeDefaultVariablesObject() {
        const layout = await this.getDocumentLayout();
        const themeConfig = await layout.getThemeConfig();
        return themeConfig.reduce((acc, item) => {
            acc[item.name] = item.defaultValue;
            return acc;
        }, {});
    }
    async getThemeVariablesObject() {
        let config;
        try {
            config = JSON.parse(await this.getSettingValue(constants_1.SETTINGS_KEYS.THEME_CONFIG_SETTINGS));
        }
        catch (error) {
            //
            // Not having a config saved should not be a real error
            //
            config = {};
        }
        return {
            ...await this.getThemeDefaultVariablesObject(),
            ...config[this.data.default_document_template],
        };
    }
    async getThemeInlineCssVariables(variableOverride = null) {
        const themeConfig = await this.getThemeConfig();
        const config = variableOverride || await this.getThemeVariablesObject();
        return themeConfig && config ? (0, themeConfig_1.default)(themeConfig, config) : '';
    }
};
Company.Entity = entity_1.default;
Company.NOTIFICATION = entity_1.NOTIFICATION;
Company.modelProperties = modelProperties_1.default;
Company = Company_1 = __decorate([
    (0, decorator_1.complexDataMix)(syncable_1.default)
    // eslint-disable-next-line no-redeclare
], Company);
exports.default = Company;
//# sourceMappingURL=../../../../src/models/company/index.js.map